var React = require('react');

function CommentInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 17l-8 5v-5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6z","stroke":"currentColor","strokeWidth":"2","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

CommentInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CommentInline;

CommentInline.default = CommentInline;
